import { StyleSheet } from '@react-pdf/renderer';

import { commonStyles } from 'src/common/pdf/common.styles';

export const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
  },
  organizationLogo: {
    width: 100,
    height: 66,
  },
  subTotalStyle: {
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingVertical: 2,
    ...commonStyles.textSmedium,
  },
});
